import { Map } from "immutable";

import { immutableRecords } from "../../types";
import { actionTypes } from "./actions";

const reducer = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.LOAD_PREFERENCES:
      return immutableRecords.PreferencesRecord(action.data);
    case actionTypes.SET_DATE_ORDER:
      return state.set("dateOrder", action.dateOrder);
    case actionTypes.SET_THOUSANDS_SEPARATOR:
      return state.set("thousandsSeparator", action.separator);
    case actionTypes.SET_SKIN:
      return state.set("skin", action.skin);
    case actionTypes.SET_AUTO_BACKUP:
      return state.set("autoBackupEnabled", action.autoBackupEnabled);
    case actionTypes.SET_AUTO_BACKUP_LOCATION:
      return state.set("autoBackupLocation", action.autoBackupLocation);
    case actionTypes.SET_AUTO_CHECK_UPDATES: {
      let change = {
        autoCheckUpdates: action.autoCheckUpdates
      };
      if (!action.autoCheckUpdates) {
        change.autoDownloadUpdates = false;
      }
      return state.merge(change);
    }
    case actionTypes.SET_AUTO_DOWNLOAD_UPDATES:
      return state.set("autoDownloadUpdates", action.autoDownloadUpdates);
    case actionTypes.SET_AUTO_CLOSE_SCRIVENER:
      return state.set("autoCloseScrivener", action.autoCloseScrivener);
    case actionTypes.SET_GLOBAL_FONT_SIZE:
      return state.set("globalFontSize", action.fontSize);
    default:
      return state;
  }
};

export default reducer;
